import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';

export const routes: Routes = [
  {
    path: 'lobby-widget',
    loadComponent: () =>
      import('./components/lobby-widget/lobby-widget.component').then(
        (m) => m.LobbyWidgetComponent,
      ),
  },
  {
    path: 'footer-widget',
    loadComponent: () =>
      import('./components/footer-widget/footer-widget.component').then(
        (m) => m.FooterWidgetComponent,
      ),
  },
  {
    path: 'win-animation-widget',
    loadComponent: () =>
      import('./components/win-animation-widget/win-animation-widget.component').then(
        (m) => m.WinAnimationWidgetComponent,
      ),
  },
  {
    path: 'win-animation-widget-brazil',
    loadComponent: () =>
      import('./components/win-animation-widget-brazil/win-animation-widget-brazil.component').then(
        (m) => m.WinAnimationWidgetBrazilComponent,
      ),
  },
  {
    path: 'won-jackpot',
    loadComponent: () =>
      import('./components/won-jackpot/won-jackpot.component').then(
        (m) => m.WonJackpotComponent,
      ),
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'footer-widget',
  },
  {
    path: '**',
    redirectTo: 'footer-widget',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
